var _style, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 16,
    y1: 51.5771,
    x2: 16,
    y2: -1.044,
    gradientTransform: "matrix(1 0 0 -1 0 34)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3172,
    style: {
      stopColor: "#2AA7DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    style: {
      stopColor: "#1985C1"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32,16c0,8.8-7.2,16-16,16S0,24.8,0,16S7.2,0,16,0S32,7.2,32,16z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.9,20.2c1,0.1,1.9-0.1,2.8-0.5c0.4-0.2,0.8-0.4,1.2-0.7c-0.5,0-0.8-0.1-1.2-0.3c-0.6-0.2-1.1-0.7-1.4-1.4 c-0.1-0.1-0.1-0.1,0.1-0.1c0.5,0.1,0.8,0.1,1-0.1c-0.3-0.1-0.5-0.1-0.6-0.3c-0.9-0.5-1.4-1.3-1.5-2.3c0-0.1,0-0.1,0.1-0.1 c0.3,0.2,0.6,0.3,1,0.3c-0.2-0.1-0.3-0.3-0.5-0.4c-0.8-0.8-0.9-2.1-0.5-3.1c0.1-0.1,0.1-0.1,0.2,0c1.3,1.5,2.8,2.3,4.7,2.6 c0.2,0.1,0.4,0.1,0.6,0.1c0.1,0,0.1-0.1,0.1-0.1c-0.2-1.2,0.3-2.3,1.4-2.8c1-0.6,2.4-0.4,3.2,0.4c0.1,0.1,0.2,0.1,0.3,0.1 c0.5-0.1,1-0.3,1.4-0.6c0.1,0,0.1-0.1,0.1-0.1c-0.2,0.6-0.6,1.1-1.2,1.5c0.5-0.1,1-0.2,1.5-0.4c0,0.1-0.1,0.1-0.1,0.1 c-0.3,0.5-0.7,0.8-1.1,1.2c-0.1,0.1-0.1,0.1-0.1,0.3c0.1,2-0.6,3.7-1.9,5.3c-1.2,1.4-2.7,2.3-4.5,2.5 C13.5,21.6,11.7,21.2,9.9,20.2C10,20.2,9.9,20.2,9.9,20.2z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.4bb8a0058f44f43ba7bd8a1af6d4bc55.svg";
export { ForwardRef as ReactComponent };